/* globals $ */

import multicheckboxEvents from './events';
import toggleClass from '../../../utils/toggleClass';

/**
 * Multiselect
 * @param {Element} element
 * @param {Object} settings
 * @return {Object}
 */
const multicheckbox = (element, settings) => {
  const { selector } = settings;
  const checkboxList = element.querySelector('[data-js-multicheckbox-list]');
  const search = element.querySelector('[data-js-multicheckbox-search]');
  const close = element.querySelector('[data-js-multicheckbox-close]');
  const clear = element.querySelector('[data-js-multicheckbox-clear]');
  const applyFilterButton = element.querySelector('[data-js-filters-apply]');
  const checkboxSelector = '[data-js-multicheckbox-checkbox]';

  const $element = $(element);
  const $search = $(search);
  const $close = $(close);
  const $clear = $(clear);
  const $applyFilterButton = $(applyFilterButton);

  let checkboxes;

  /**
   * Constructor
   */
  function constructor() {
    bindEvents();
  }

  /**
   * Bind handlers to events
   */
  function bindEvents() {
    $search.on('keyup', onSearchChange);
    $close.on('click', onCloseClick);
    $clear.on('click', onClearClick);
    $applyFilterButton.on('click', onCloseClick);

    $element
      .on(multicheckboxEvents.SET_DATA, onSetData)
      .on(multicheckboxEvents.CLEAR, onClear)
      .on(multicheckboxEvents.CLEAR_ALL, onClearAll);

    $(checkboxList).on('change', '[data-js-multicheckbox-checkbox]', onChange);
  }

  /**
   * Change event handler
   */
  function onChange() {
    const selectedOptions = checkboxes
      .filter(checkbox => checkbox.checked)
      .reduce((acc, checkbox) => {
        acc.push({ id: checkbox.value, name: checkbox.getAttribute('name'), selector });
        return acc;
      }, []);

    $element.trigger(multicheckboxEvents.CHANGE, { selectedOptions });
    updateCount(selectedOptions.length);
  }

  /**
   * Search change event handler
   */
  function onSearchChange() {
    const query = search.value.toLowerCase();
    const toggleCheckbox = (toggle, checkbox) => {
      $(checkbox)
        .closest('.multicheckbox__item')
        .toggleClass('_is_hidden', toggle);
    };

    checkboxes.forEach(toggleCheckbox.bind(null, false));
    checkboxes
      .filter(checkbox => checkbox.getAttribute('data-js-searchId').indexOf(query) === -1)
      .forEach(toggleCheckbox.bind(null, true));
  }

  /**
   * Clear event handler
   * @param {Event} event
   * @param {Object} eventData
   */
  function onClear(event, { id }) {
    checkboxes
      .filter(checkbox => checkbox.value === id)
      .forEach(checkbox => (checkbox.checked = false));

    onChange();
  }

  /**
   * Clear event handler
   */
  function onClearAll() {
    checkboxes.forEach(checkbox => (checkbox.checked = false));
    updateCount(0);
  }

  /**
   * Updates the selected filters count
   * @param {int} numSelected
   */
  function updateCount(numSelected) {
    clear.setAttribute('data-js-multicheckbox-count', numSelected);
    toggleClass(clear, '_has_count', !!numSelected);
    $element.trigger(multicheckboxEvents.NUM_SELECTED_CHANGED, { numSelected });
  }

  /**
   * Set data event handler
   * @param {Event} event
   * @param {Object} eventData
   */
  function onSetData(event, { options }) {
    if (options) {
      checkboxList.innerHTML = options.reduce((acc, { id, name }) => acc + renderOption(name, id), '');
    }

    checkboxes = [...checkboxList.querySelectorAll(checkboxSelector)];
  }

  /**
   * Returns the rendered option HTML for a select
   * @param {String} name
   * @param {String} value
   * @return {String}
   */
  function renderOption(name, value) {
    const searchId = name.toLowerCase();

    return `
      <li class="multicheckbox__item">
        <input type="checkbox" name="${name}" id="${value}" value="${value}" class="multicheckbox__checkbox" data-js-searchId="${searchId}" data-js-multicheckbox-checkbox>
        <label class="multicheckbox__label" for="${value}">${name}</label>
      </li>
    `;
  }

  /**
   * Clear click event handler
   */
  function onClearClick() {
    onClearAll();
    onChange();
  }

  /**
   * Close click event handler
   */
  function onCloseClick() {
    element.classList.remove('_is_visible');
  }

  constructor();

  return {};
};

export default multicheckbox;



// WEBPACK FOOTER //
// ./resources/assets/js/specifics/filters/multicheckbox/multicheckbox.js